/* import __COLOCATED_TEMPLATE__ from './template-override-styles.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();